
import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { noEscChar, required } from '../../helpers/commonYupValidations';

const ClaimStatusFieldWithModal = ({ closeModal, isOpen, setModalOpen, action, nilFSRVALUE, setNILFSRVALUE }) => {
    let claimStatusReason = nilFSRVALUE || action?.claimDetails?.claimWithdrawnReason || "";
    const initialValues = {
        withdrawn: claimStatusReason,
    };

    const validationSchema = Yup.object().shape({
        withdrawn: Yup.string().matches(noEscChar("NIL FSR Reason").regex, noEscChar("NIL FSR Reason").msg).required(required("NIL FSR Reason").msg),
    });

    const handleSubmit = (values) => {
        setModalOpen(false);
        localStorage.setItem("claimReasion", values?.withdrawn)
        setNILFSRVALUE(values?.withdrawn)
        // getClaimStatusValue({ withdrawn: values?.withdrawn, isSubmit: true });

    };

    return (
        <Modal isOpen={isOpen} backdrop={'static'}>
            <ModalHeader toggle={closeModal}>NIL FSR Reason</ModalHeader>
            <ModalBody>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ touched, errors, dirty }) =>
                        <Form role="form">
                            <div>
                                <Field
                                    type="text"
                                    className={`form-control ${touched.withdrawn && errors.withdrawn ? 'is-invalid' : ''}`}
                                    name="withdrawn"
                                    placeholder="Enter NIL FSR Reason"
                                />
                                {errors.withdrawn && touched.withdrawn ? (
                                    <p className="errorMsg">{errors.withdrawn}</p>) : null}
                            </div>
                            {<ModalFooter className="border-0">
                                <Button color="primary" type="submit" className="ITC_Blue_color" disabled={!dirty}>
                                    OK
                                </Button>
                            </ModalFooter>}
                        </Form>
                    }
                </Formik >
            </ModalBody >
        </Modal >
    );
};

export default ClaimStatusFieldWithModal;


